import React, { Component } from "react";
import { Localization } from "../localization/index";
import { PakleanImages } from "../images/index";
import { Colors } from "../colors/index";
import { Map, GoogleApiWrapper, InfoWindow, Marker } from "google-maps-react";

import Modal from "react-modal";
import { ClipLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import moment from "moment-jalaali";
import { DatePicker } from "react-advance-jalaali-datepicker";

class ShowDriversScreen extends Component {
  state = {
    latitude: 35.69077,
    longitude: 51.389301,
    error: null,
    isLoading: true,
    value: null,
    log: null,
    movingOnMap: false,
    pinStyle: styles.markerStop,
    addr: "",
    minBasketSize: 0,
    logisticFee: 0,
    addressDetails: Localization.Farsi.AddressDetails,
    searchAddrResult: [],
    showSearchResult: false,
    searching: false,
    showAddressModal: false,
    saveAddress: false,
    addressUnit: "",
    addressNo: "",
    addressTopic: "",
    showAddreeNameSection: true,
    showAddresNameRequest: false,
    addressNameRequestHeight: 0,
    addressTopicButtonStyle: styles.confirmButtonModalInactive,
    addressDetailsModalHeight: 0,
    isMapLoaded: null,
    showAddressNotComplete: false,
    campaignModal: false,
    campaignItem: undefined,

    drivers: [],
    selectedDate: moment(),
    selectedTs: undefined,

    selectedDrivers: [],
    selectedMission: null,

    deliverOrders: [],
    fetchOrders: [],
    laundryMissions: [],
    selectedPriority: 0,
  };

  constructor(props) {
    super(props);
    this.continuousLoading = true;
    this.isToday = true;
    this.interval = undefined;
    this.interval2 = undefined;
  }

  // refreshDate = () => {
  //     let time = moment()
  //     let d = new Date(time._d)
  //     d.setHours(0)
  //     this.setState({ selectedDate: d.getTime() })
  // }

  onDateChanged = (unix, formatted) => {
    console.log(unix);
    console.log(formatted);
    // formatted = formatted + "99784230"
    if (this.map) {
      let date = moment(formatted + " 15:00:00", "jYYYY/jM/jD HH:mm:ss");
      console.log(date._d.getTime());

      let today = moment();

      if (
        date._d.getDay() == today._d.getDay() &&
        date._d.getMonth() == today._d.getMonth() &&
        date._d.getFullYear() == today._d.getFullYear()
      )
        this.isToday = true;
      else this.isToday = false;

      // date._d.setHours(0)
      // console.log(date)
      console.log(today._d.getTime());

      console.log(date._d.getTime());
      this.setState(
        { selectedDate: date, selectedTs: date._d.getTime() },
        () => {
          if (this.isToday) {
            console.log("todayyyy");

            this.clearAllmarkers();
            this.continuousLoading = false;

            for (let i = 0; i < this.driverMarkers.length; i++) {
              let driverMarker = this.driverMarkers[i];
              this.getDriverMissions(
                driverMarker.driver,
                this.getDriverIndex(driverMarker)
              );
            }

            this.interval2 = setInterval(async () => {
              this.clearAllmarkers();
              this.continuousLoading = false;

              for (let i = 0; i < this.driverMarkers.length; i++) {
                let driverMarker = this.driverMarkers[i];
                await this.getDriverMissions(
                  driverMarker.driver,
                  this.getDriverIndex(driverMarker)
                );
              }
            }, 60000);
          } else {
            console.log(" not  todayyyy");

            clearInterval(this.interval);
            clearInterval(this.interval2);

            this.clearAllmarkers();
            this.continuousLoading = false;

            for (let i = 0; i < this.driverMarkers.length; i++) {
              let driverMarker = this.driverMarkers[i];
              this.getDriverMissions(
                driverMarker.driver,
                this.getDriverIndex(driverMarker)
              );
            }
          }
        }
      );
    }
  };

  componentWillUnmount = () => {
    clearInterval(this.interval);
    clearInterval(this.interval2);
  };

  handleMapReady = (mapProps, map) => {
    this.map = map;

    let d = new Date(this.state.selectedDate._d);
    d.setHours(0);
    this.setState({ selectedTs: d.getTime() }, () => this.getDrivers(map));

    map.addListener("idle", () => {
      console.log({ lng: map.center.lng(), lat: map.center.lat() });
      this.setState({
        latitude: map.center.lat(),
        longitude: map.center.lng(),
      });
    });
  };

  pinSymbol = (index, type) => {
    let color;
    let icon;
    let deliverIcon;
    let fetchIcon;
    let laundryIcon;

    switch (index) {
      case 0:
        color = "#9B59B6";
        icon = PakleanImages.vanViolet;
        // fetchIcon = PakleanImages.fetchViolet
        deliverIcon = PakleanImages.deliverViolet;
        laundryIcon = PakleanImages.laundryViolet;
        break;

      case 1:
        color = "#000080";
        icon = PakleanImages.vanNavy;
        // fetchIcon = PakleanImages.fetchNavy
        deliverIcon = PakleanImages.deliverNavy;
        laundryIcon = PakleanImages.laundryNavy;

        break;

      case 2:
        color = "#E67E22";
        icon = PakleanImages.vanOrange;
        // fetchIcon = PakleanImages.fetchOrange
        deliverIcon = PakleanImages.deliverOrange;
        laundryIcon = PakleanImages.laundryOrange;

        break;

      case 3:
        color = "#2ECC71";
        icon = PakleanImages.vanGreen;
        // fetchIcon = PakleanImages.fetchGreen
        deliverIcon = PakleanImages.deliverGreen;
        laundryIcon = PakleanImages.laundryGreen;

        break;

      case 4:
        color = "#3498DB";
        icon = PakleanImages.vanBlue;
        // fetchIcon = PakleanImages.fetchBlue
        deliverIcon = PakleanImages.deliverBlue;
        laundryIcon = PakleanImages.laundryBlue;

        break;

      case 5:
        color = "#FF4722";
        icon = PakleanImages.vanRed;
        // fetchIcon = PakleanImages.fetchRed
        deliverIcon = PakleanImages.deliverRed;
        laundryIcon = PakleanImages.laundryRed;

        break;

      case 6:
        color = "#C762AD";
        icon = PakleanImages.vanPink;
        // fetchIcon = PakleanImages.fetchPink
        deliverIcon = PakleanImages.deliverPink;
        laundryIcon = PakleanImages.laundryPink;

        break;

      case 7:
        color = "#660000";
        icon = PakleanImages.vanMaroon;
        // fetchIcon = PakleanImages.fetchBlue
        deliverIcon = PakleanImages.deliverMaroon;
        break;

      case 8:
        color = "#d8eb34";
        icon = PakleanImages.vanYellow;
        // fetchIcon = PakleanImages.fetchBlue
        deliverIcon = PakleanImages.deliverYellow;
        laundryIcon = PakleanImages.laundryYellow;

        break;

      case 9:
        color = "#000000";
        icon = PakleanImages.vanBlack;
        // fetchIcon = PakleanImages.fetchBlue
        deliverIcon = PakleanImages.deliverBlack;
        laundryIcon = PakleanImages.laundryBlack;

        break;
      case 10:
        color = "#137d8a";
        icon = PakleanImages.vanSG;
        // fetchIcon = PakleanImages.fetchBlue
        deliverIcon = PakleanImages.deliverSG;
        laundryIcon = PakleanImages.laundrySG;

        break;

      case 11:
        color = "#b8ffc3";
        icon = PakleanImages.vanP;
        // fetchIcon = PakleanImages.fetchBlue
        deliverIcon = PakleanImages.deliverP;
        laundryIcon = PakleanImages.laundryP;

        break;
      case 12:
        color = "#ffb400";
        icon = PakleanImages.vanYP;
        // fetchIcon = PakleanImages.fetchBlue
        deliverIcon = PakleanImages.deliverYP;
        laundryIcon = PakleanImages.laundryYP;

        break;
      case 13:
        color = "#8a4848";
        icon = PakleanImages.vanZZ;
        // fetchIcon = PakleanImages.fetchBlue
        deliverIcon = PakleanImages.deliverZZ;
        laundryIcon = PakleanImages.laundryZZ;

        break;

      case 14:
        color = Colors.ColorNew01;
        icon = PakleanImages.vanNew01;
        // fetchIcon = PakleanImages.fetchBlue
        deliverIcon = PakleanImages.deliverNew01;
        laundryIcon = PakleanImages.laundryNew01;

        break;

      case 15:
        color = Colors.ColorNew02;
        icon = PakleanImages.vanNew02;
        // fetchIcon = PakleanImages.fetchBlue
        deliverIcon = PakleanImages.deliverNew02;
        laundryIcon = PakleanImages.laundryNew02;

        break;

      default:
        break;
    }

    if (type === "fetch") {
      return {
        path: "M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0",
        fillColor: color,
        fillOpacity: 1,
        strokeColor: "#000",
        strokeWeight: 2,
        scale: 1,
      };
    }

    if (type === "fetchDone") {
      return {
        path: "M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0",
        fillColor: "#918F8F",
        fillOpacity: 1,
        strokeColor: "#000",
        strokeWeight: 2,
        scale: 1,
      };
    }

    if (type === "deliver") {
      return deliverIcon;
    }

    if (type === "laundry") {
      return laundryIcon;
    }
    if (type === "deliverDone") {
      return PakleanImages.deliverDone;
    }

    if (type === "laundryDone") {
      return PakleanImages.laundryDone;
    }

    if (type === "driver") {
      return icon;
    }

    if (type === "checkbox") {
      return color;
    }
  };

  clearAllmarkers = () => {
    for (let i = 0; i < this.allMarkers.length; i++) {
      this.allMarkers[i].setMap(null);
    }
  };

  clearMarkers = (driver) => {
    for (let i = 0; i < this.driverMarkers.length; i++) {
      if (this.driverMarkers[i].driver._id === driver._id) {
        let markers = this.driverMarkers[i].markers;
        for (let j = 0; j < markers.length; j++) {
          markers[j].setMap(null);
        }
        if (this.driverMarkers[i].driverPin)
          this.driverMarkers[i].driverPin.setMap(null);
        this.driverMarkers.splice(i, 1);
        return;
      }
    }
  };

  getDriverIndex = (driverMarker) => {
    let drivers = this.state.drivers;

    for (let i = 0; i < drivers.length; i++) {
      if (drivers[i]._id === driverMarker.driver._id) return i;
    }
  };

  getDrivers = () => {
    this.setState({ isLoading: true });

    this.allMarkers = [];
    this.driverMarkers = [];

    fetch("https://pnl.api.paklean.com/puser/drivers", {
      method: "GET",
      headers: {
        Authorization: global.authorization,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.drivers) {
          this.setState({
            isLoading: false,
            drivers: responseJson.drivers,
          });
          this.interval = setInterval(async () => {
            this.clearAllmarkers();
            this.continuousLoading = false;

            for (let i = 0; i < this.driverMarkers.length; i++) {
              let driverMarker = this.driverMarkers[i];
              await this.getDriverMissions(
                driverMarker.driver,
                this.getDriverIndex(driverMarker)
              );
            }
          }, 60000);
        } else {
          this.setState({ isLoading: false }, () => {
            toast(Localization.Farsi.ErrorUpdating);
          });
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
      });
  };

  setPriority = (orderId, priority) => {
    this.setState({ isLoading: true });
    var data = {
      orderId: orderId,
      priority: priority,
    };

    console.log("priority data:", data);

    fetch("https://pnl.api.paklean.com/puser/order/priority", {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Authorization: global.authorization,
        "Content-Type": "application/json",
      },
    })
      .then(() => {
        this.setState({ isLoading: false });
        console.log("@@@@@@@@@@@@@@@@");
        console.log(this.allMarkers.length);
        for (var i = 0; i < this.allMarkers.length; i++) {
          var element = this.allMarkers[i];
          console.log(element);
          if (this.allMarkers[i].mission?._id === orderId) {
            this.allMarkers[i].mission.priority = priority;
            this.allMarkers[i].title = "" + priority;
            console.log(
              "The local priority of " +
                element.mission.shortId +
                " : " +
                priority
            );
          }
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
      });
  };

  getDriverMissions = (driver, driverIndex) => {
    let map = this.map;

    let self = this;

    if (this.continuousLoading) this.setState({ isLoading: true });

    let endDate = this.state.selectedTs;

    // fetch('http://panel.api.paklean.com/puser/driver/missions/' + driver._id + "/" + this.state.selectedTs + "/" + endDate, {
    //     method: 'GET',
    //     headers: {
    //         Authorization: global.authorization,
    //         'Content-Type': 'application/json'
    //     },

    // })

    fetch(
      "https://pnl.api.paklean.com/puser/driver/missions/" +
        driver._id +
        "/" +
        this.state.selectedTs,
      {
        method: "GET",
        headers: {
          Authorization: global.authorization,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson) {
          this.setState({
            isLoading: false,
            // missions: responseJson.missions
            fetchOrders: responseJson.fetchOrders,
            deliverOrders: responseJson.deliverOrders,
            laundryMissions: responseJson.laundryMissions,
          });

          // let missions = responseJson.missions;
          let fetchOrders = responseJson.fetchOrders;
          let deliverOrders = responseJson.deliverOrders;
          let laundryMissions = responseJson.laundryMissions;

          let markers = [];
          let index = 0;
          let driverPin = null;

          if (fetchOrders.length == 0 && deliverOrders.length == 0) {
            toast("راننده موردنظر عملیاتی در روز مشخص شده ندارد");
          } else {
            if (fetchOrders[0]) {
              if (
                fetchOrders[0].driver_.location &&
                fetchOrders[0].driver_.location.geo
              ) {
                if (!fetchOrders[0].laundry_)
                  fetchOrders[0].laundry_ = { name: "--" };
                let driverGeo;

                driverGeo = new this.props.google.maps.LatLng(
                  fetchOrders[0].driver_.location.geo[0],
                  fetchOrders[0].driver_.location.geo[1]
                );

                driverPin = new this.props.google.maps.Marker({
                  position: driverGeo,
                  map: map,
                  title: fetchOrders[0].priority
                    ? fetchOrders[0].priority + ""
                    : "-1",
                  icon: this.pinSymbol(driverIndex, "driver"),
                });

                this.allMarkers.push(driverPin);
              } else {
                toast("لوکیشن " + fetchOrders[0].driver_.name + " مشخص نیست.");
              }
            } else {
              if (
                deliverOrders[0].driver_.location &&
                deliverOrders[0].driver_.location.geo
              ) {
                if (!deliverOrders[0].laundry_)
                  deliverOrders[0].laundry_ = { name: "--" };

                let driverGeo;

                driverGeo = new this.props.google.maps.LatLng(
                  deliverOrders[0].driver_.location.geo[0],
                  deliverOrders[0].driver_.location.geo[1]
                );

                driverPin = new this.props.google.maps.Marker({
                  position: driverGeo,
                  map: map,
                  title: deliverOrders[0].priority
                    ? deliverOrders[0].priority + ""
                    : "-1",
                  icon: this.pinSymbol(driverIndex, "driver"),
                });

                this.allMarkers.push(driverPin);
              } else {
                toast(
                  "لوکیشن " + deliverOrders[0].driver_.name + " مشخص نیست."
                );
              }
            }
          }

          if (fetchOrders.length > 0) {
            for (var i = 0; i < fetchOrders.length; i++) {
              if (fetchOrders[i].addressGeo && fetchOrders[i].addressGeo.geo) {
                var location = new this.props.google.maps.LatLng(
                  fetchOrders[i].addressGeo.geo[1],
                  fetchOrders[i].addressGeo.geo[0]
                );
                if (!fetchOrders[i].laundry_)
                  fetchOrders[i].laundry_ = { name: "--" };

                var icon;

                if (fetchOrders[i].fetchmission_.state === "Done")
                  icon = this.pinSymbol(driverIndex, "fetchDone");
                else icon = this.pinSymbol(driverIndex, "fetch");

                markers[index] = new this.props.google.maps.Marker({
                  position: location,
                  map: map,
                  icon: icon,
                  title: fetchOrders[i].priority
                    ? "" + fetchOrders[i].priority
                    : "-1",
                  __idid__: index,
                  mission: fetchOrders[i],
                });

                this.allMarkers.push(markers[index]);

                index++;

                console.log(fetchOrders[i].priority);
              } else
                toast.error(
                  "آدرس دریافت سفارش " +
                    fetchOrders[i].user_.name +
                    " با کد " +
                    fetchOrders[i].shortId +
                    " پین نشده است",
                  { autoClose: 30000 }
                );
            }
          }

          if (deliverOrders.length > 0) {
            for (var i = 0; i < deliverOrders.length; i++) {
              if (
                deliverOrders[i].deliverAddressGeo &&
                deliverOrders[i].deliverAddressGeo.geo
              ) {
                var location = new this.props.google.maps.LatLng(
                  deliverOrders[i].deliverAddressGeo.geo[1],
                  deliverOrders[i].deliverAddressGeo.geo[0]
                );
                if (!deliverOrders[i].laundry_)
                  deliverOrders[i].laundry_ = { name: "--" };

                var icon;

                if (
                  deliverOrders[i].delivermission_.state === "Done" ||
                  deliverOrders[i].status === "doneDebtor" ||
                  deliverOrders[i].status === "done"
                )
                  icon = this.pinSymbol(driverIndex, "deliverDone");
                else icon = this.pinSymbol(driverIndex, "deliver");

                markers[index] = new this.props.google.maps.Marker({
                  position: location,
                  map: map,
                  icon: icon,
                  __idid__: index,
                  title: deliverOrders[i].priority
                    ? deliverOrders[i].priority + ""
                    : "-1",
                  mission: deliverOrders[i],
                });

                this.allMarkers.push(markers[index]);

                index++;
              } else
                toast.error(
                  "آدرس ارسال سفارش " +
                    deliverOrders[i].user_.name +
                    " با کد " +
                    deliverOrders[i].shortId +
                    " پین نشده است",
                  { autoClose: 30000 }
                );
            }
          }

          if (laundryMissions.length > 0) {
            for (var i = 0; i < laundryMissions.length; i++) {
              if (laundryMissions[i].source) {
                var location = new this.props.google.maps.LatLng(
                  laundryMissions[i].source.geo[1],
                  laundryMissions[i].source.geo[0]
                );

                laundryMissions[i].laundry_ = {
                  name: laundryMissions[i].customer.name,
                };
                laundryMissions[i].user_ = {
                  name: laundryMissions[i].customer.name,
                  username: laundryMissions[i].customer.tel,
                };
                laundryMissions[i].deliverAddress =
                  laundryMissions[i].source.address;
                laundryMissions[i].persianFetchDate =
                  laundryMissions[i].persianDate;
                laundryMissions[i].persianDeliverDate =
                  laundryMissions[i].persianDate;
                console.log(laundryMissions[i]);
                // laundryMissions[i].status = laundryMissions[i].state;
                var icon;

                if (
                  laundryMissions[i].state === "Done" ||
                  laundryMissions[i].state === "done"
                )
                  icon = this.pinSymbol(driverIndex, "laundryDone");
                else icon = this.pinSymbol(driverIndex, "laundry");

                markers[index] = new this.props.google.maps.Marker({
                  position: location,
                  map: map,
                  icon: icon,
                  __idid__: index,
                  title: laundryMissions[i].priority
                    ? laundryMissions[i].priority + ""
                    : "-1",
                  mission: laundryMissions[i],
                });

                this.allMarkers.push(markers[index]);

                index++;
              } else toast.error("خطا", { autoClose: 30000 });
            }
          }

          // for (var i = 0; i < missions.length; i++) {
          //     if (missions[i].order.addressGeo && missions[i].order.addressGeo.geo) {
          //         var location = new this.props.google.maps.LatLng(missions[i].order.addressGeo.geo[1], missions[i].order.addressGeo.geo[0]);

          //         var icon

          //         if (missions[i].type === 'fetch') {
          //             if (missions[i].state === 'Done' || missions[i].order.status === 'doneDebtor')
          //                 icon = this.pinSymbol(driverIndex, 'fetchDone');
          //             else
          //                 icon = this.pinSymbol(driverIndex, 'fetch');
          //         }

          //         else {
          //             if (missions[i].state === 'Done' || missions[i].order.status === 'doneDebtor')
          //                 icon = this.pinSymbol(driverIndex, 'deliverDone');
          //             else
          //                 icon = this.pinSymbol(driverIndex, 'deliver');

          //         }

          //         markers[index] = new this.props.google.maps.Marker({
          //             position: location,
          //             map: map,
          //             icon: icon,
          //             __idid__: index,
          //             mission: missions[i]
          //         });

          //         this.allMarkers.push(markers[index])

          //         index++

          //     }

          //     else
          //         toast.error('سفارش ' + missions[i].customer.name + ' با کد ' + missions[i].order.shortId + ' پین نشده است', { autoClose: 30000 })
          // }

          let driverMarker = {
            driver: driver,
            markers: markers,
            driverPin: driverPin,
          };
          this.pushDriverMarker(driverMarker);

          markers.forEach(function (marker) {
            console.log(marker);
            // Set up a click event listener for each marker in the array
            marker.addListener("click", function () {
              console.log("called");

              self.setState({
                selectedMission: marker.mission,
                selectedPriority: marker.mission.priority,
              });
            });
          });
        } else {
          this.setState({ isLoading: false }, () => {
            toast(Localization.Farsi.ErrorUpdating);
          });
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
      });
  };

  pushDriverMarker = (driverMarker) => {
    for (let i = 0; i < this.driverMarkers.length; i++) {
      if (driverMarker.driver._id === this.driverMarkers[i].driver._id) {
        this.driverMarkers.splice(i, 1);
      }
    }
    this.driverMarkers.push(driverMarker);
  };

  correctName = (name) => {
    let array = name.split(" ");
    return array[array.length - 1];
  };

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <div
            style={{
              position: "absolute",
              top: 10,
              zIndex: 50,
              backgroundColor: "white",
              direction: "rtl",
              border: "solid 1px black",
              borderRadius: 5,
            }}
          >
            <DatePicker
              timePicker={false}
              format="jYYYY/jMM/jDD"
              placeholder="انتخاب تاریخ"
              value={this.state.selectedDate}
              preSelected={moment().format("jYYYY/jMM/jDD")}
              onChange={this.onDateChanged}
            />
          </div>

          <div
            style={{
              padding: 10,
              position: "absolute",
              top: 10,
              backgroundColor: "white",
              left: 10,
              zIndex: 50,
              border: "solid",
              borderRadius: 10,
              borderWidth: 1,
              display: "flex",
              flexDirection: "column",
              width: 180,
            }}
          >
            {this.state.drivers.map((driver, index) => (
              <div
                key={driver._id}
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  padding: 5,
                }}
              >
                <div
                  style={{
                    flex: 2,
                    backgroundColor: this.pinSymbol(index, "checkbox"),
                    width: 10,
                    height: 10,
                  }}
                ></div>
                <p style={{ flex: 10, padding: "0 10px", fontSize: 18 }}>
                  {this.correctName(driver.name)}
                </p>
                <input
                  style={{ flex: 1 }}
                  type="checkbox"
                  checked={this.state.selectedDrivers.includes(driver._id)}
                  onChange={() => {
                    let globalIndex = index;
                    let selectedDrivers = [...this.state.selectedDrivers];

                    if (selectedDrivers.includes(driver._id)) {
                      let index = selectedDrivers.indexOf(driver._id);
                      selectedDrivers.splice(index, 1);
                      this.setState({ selectedDrivers }, () => {
                        this.clearMarkers(driver);
                        console.log(this.state.selectedDrivers);

                        if (selectedDrivers.length === 0) {
                          clearInterval(this.interval);
                          clearInterval(this.interval2);
                        }
                      });
                    } else {
                      selectedDrivers.push(driver._id);
                      this.setState({ selectedDrivers }, () => {
                        this.continuousLoading = true;
                        this.getDriverMissions(driver, globalIndex);
                        console.log(this.state.selectedDrivers);
                      });
                    }
                  }}
                />
              </div>
            ))}
          </div>

          {this.state.selectedMission ? (
            <div
              onAuxClick={() => this.setState({ selectedMission: null })}
              style={{
                fontSize: 18,
                width: "20%",
                padding: 10,
                position: "absolute",
                top: 10,
                backgroundColor: "white",
                right: 10,
                zIndex: 50,
                border: "solid",
                borderRadius: 10,
                borderWidth: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p>نام مشتری: {this.state.selectedMission.user_.name}</p>
              <div
                style={{
                  width: "100%",
                  height: 1,
                  backgroundColor: "green",
                  margin: "5px 0px",
                }}
              />

              <p>شماره مشتری: {this.state.selectedMission.user_.username}</p>
              <div
                style={{
                  width: "100%",
                  height: 1,
                  backgroundColor: "green",
                  margin: "5px 0px",
                }}
              />

              <p>کد سفارش: {this.state.selectedMission.shortId}</p>
              <div
                style={{
                  width: "100%",
                  height: 1,
                  backgroundColor: "green",
                  margin: "5px 0px",
                }}
              />

              <p>خشکشویی: {this.state.selectedMission.laundry_.name}</p>
              <div
                style={{
                  width: "100%",
                  height: 1,
                  backgroundColor: "green",
                  margin: "5px 0px",
                }}
              />

              <p>تاریخ دریافت: {this.state.selectedMission.persianFetchDate}</p>
              <div
                style={{
                  width: "100%",
                  height: 1,
                  backgroundColor: "green",
                  margin: "5px 0px",
                }}
              />

              <p>
                تاریخ ارسال: {this.state.selectedMission.persianDeliverDate}
              </p>
              <div
                style={{
                  width: "100%",
                  height: 1,
                  backgroundColor: "green",
                  margin: "5px 0px",
                }}
              />

              <p>وضعیت: {this.state.selectedMission.status}</p>
              <div
                style={{
                  width: "100%",
                  height: 1,
                  backgroundColor: "green",
                  margin: "5px 0px",
                }}
              />

              <p>شماره کیسه: {this.state.selectedMission.bags}</p>
              <div
                style={{
                  width: "100%",
                  height: 1,
                  backgroundColor: "green",
                  margin: "5px 0px",
                }}
              />

              <p>آخرین مکان :
                {this.state.selectedMission.lastLocation}</p>
              <div
                style={{
                  width: "100%",
                  height: 1,
                  backgroundColor: "green",
                  margin: "5px 0px",
                }}
              />

              <p>
                آدرس:{" "}
                {this.state.selectedMission.fetchmission_
                  ? this.state.selectedMission.address
                  : this.state.selectedMission.deliverAddress}
              </p>
              <div
                style={{
                  width: "100%",
                  height: 1,
                  backgroundColor: "green",
                  margin: "5px 0px",
                }}
              />

              {/* <p>اولویت: {this.state.selectedMission.priority}</p> */}
              <div style={{ display: "flex", gap: "0 12px" }}>
                <input
                  style={{
                    width: "100%",
                    height: "20px",
                    border: "1px solid green",
                  }}
                  value={this.state.selectedPriority}
                  onChange={
                    (e) => this.setState({ selectedPriority: e.target.value })
                    // (this.state.selectedPriority = )
                  }
                />
                <button
                  style={{
                    width: "100px",
                    height: "20px",
                    backgroundColor: "green",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#ffff",
                  }}
                  onClick={() => {
                    this.setPriority(
                      this.state.selectedMission._id,
                      this.state.selectedPriority
                    );
                  }}
                >
                  ثبت
                </button>
              </div>
              <div
                style={{
                  width: "100%",
                  height: 1,
                  backgroundColor: "green",
                  margin: "5px 0px",
                }}
              />
            </div>
          ) : null}

          <Map
            google={this.props.google}
            style={{ width: "100%", height: "100%" }}
            initialCenter={{
              lat: this.state.latitude,
              lng: this.state.longitude,
            }}
            zoom={12}
            zoomControl={false}
            mapTypeControl={false}
            streetViewControl={false}
            fullscreenControl={false}
            onReady={this.handleMapReady}
          />
        </div>

        <ToastContainer
          closeButton={false}
          hideProgressBar
          rtl
          limit={3}
          style={{ textAlign: "center", color: "black" }}
          autoClose={2000}
          pauseOnFocusLoss={false}
          position="bottom-center"
        />

        <Modal isOpen={this.state.isLoading} style={styles.spinnerStyle}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              WebkitBoxPack: "center",
              WebkitBoxPack: "center",
              WebkitBoxAlign: "center",
              alignItems: "center",
              WebkitBoxAlign: "center",
            }}
          >
            <ClipLoader
              size={100}
              color={Colors.SpinnerColor}
              loading={this.state.isLoading}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyCHGw0iRJC_-a6wlrGumFbTT0hrf80DemE",
})(ShowDriversScreen);

const styles = {
  modalStyles: {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      padding: 0,
      transform: "translate(-50%, -50%)",
    },
    overlay: {
      zIndex: 10,
    },
  },

  modalStylesNotComplete: {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      padding: 0,
      transform: "translate(-50%, -50%)",
    },
    overlay: {
      zIndex: 10,
      backgroundColor: "rgba(0, 0, 0, 0.85)",
    },
  },
  spinnerStyle: {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      border: "none",
      outline: "none",
      transform: "translate(-50%, -50%)",
      backgroundColor: "transparent",
    },
    overlay: {
      zIndex: 10,
    },
  },

  content: {
    position: "fixed",
    // paddingTop: 50,
    width: "100%",
    height: "100%",
    display: "flex",
    WebkitBoxOrient: "vertical",
    flexDirection: "column",
    alignItems: "center",
    WebkitBoxAlign: "center",
  },

  container: {
    // flex: 1,
    // display: 'flex',
    // alignItems: 'center', WebkitBoxAlign:'center',
    // justifyContent: 'center'

    display: "-webkit-box",
    display: "-moz-box",
    display: "-ms-flexbox",
    display: "-webkit-flex",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: "auto",
    justifyContent: "stretch",
    alignItems: "flex-start",
    WebkitBoxOrient: "vertical",
    WebkitBoxDirection: "normal",
    WebkitFlexDirection: "column",
    WebkitFlexGrow: 1,
    WebkitFlexShrink: 0,
    WebkitFlexBasis: "auto",
    WebkitBoxPack: "stretch",
    WebkitJustifyContent: "stretch",
    WebkitBoxAlign: "start",
    WebkitAlignItems: "flex-start",
  },

  innerModalcontainer: {
    flex: 1,
    WebkitBoxOrient: "vertical",
    flexDirection: "column",
    padding: 10,
    display: "flex",
    alignItems: "center",
    WebkitBoxAlign: "center",
    justifyContent: "center",
  },
  mapPin: {
    zIndex: 2,
    width: 50,
    height: 50,
  },

  markerStyle: {
    height: 100,
    width: 100,
    top: "calc(50% - 97px)",
    left: "calc(50vw - 50px)",
    position: "absolute",
  },

  addrText: {
    color: "black",
    textAlign: "center",
    flexWrap: "wrap",
    fontSize: 12,
  },

  orderBar: {
    display: "flex",
    flex: 1,
    width: "100%",
    flexDirection: "row-reverse",
    justifyContent: "center",
    WebkitBoxPack: "center",
    alignItems: "center",
    WebkitBoxAlign: "center",
    height: 50,
    border: "none",
    outline: "none",
    backgroundColor: "rgba(250, 250, 250, 1)",
    borderColor: "#BDBDBD",
    textAlign: "right",
  },

  orderBarChilds: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    WebkitBoxPack: "center",
    alignItems: "center",
    WebkitBoxAlign: "center",
    height: 50,
    padding: 5,
    border: "none",
    outline: "none",
    backgroundColor: "rgba(250, 250, 250, 1)",
    textAlign: "center",
  },

  shortIdInput: {
    display: "flex",
    width: "100%",
    fontSize: 14,
    justifyContent: "center",
    WebkitBoxPack: "center",
    alignItems: "center",
    WebkitBoxAlign: "center",
    height: 50,
    border: "none",
    outline: "none",
    backgroundColor: "rgba(250, 250, 250, 1)",
    borderColor: "#BDBDBD",
    textAlign: "center",
  },

  textAddressInput: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    WebkitBoxPack: "center",
    alignItems: "center",
    WebkitBoxAlign: "center",
    height: 40,
    border: "none",
    outline: "none",
    backgroundColor: "rgba(250, 250, 250, 1)",
    borderColor: "#BDBDBD",
    textAlign: "right",
  },

  textInputContainer: {
    display: "flex",
    backgroundColor: "transparent",
    position: "absolute",
    left: 5,
    right: 5,
    zIndex: 2,
    WebkitBoxOrient: "horizontal",
    flexDirection: "row",
    justifyContent: "center",
    WebkitBoxPack: "center",
    alignItems: "center",
    WebkitBoxAlign: "center",
    borderWidth: 1,
    height: 100,
    borderRadius: 10,
    marginTop: 8,
    boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.2)",
    paddingLeft: 20,
    paddingRight: 20,
    backgroundColor: "rgba(250, 250, 250, 1)",
    borderColor: "black",
  },
  textInputModal: {
    width: "100%",
    display: "flex",
    WebkitBoxOrient: "horizontal",
    flexDirection: "row",
    justifyContent: "center",
    WebkitBoxPack: "center",
    alignItems: "center",
    WebkitBoxAlign: "center",
    border: "solid",
    borderWidth: 1,
    height: 50,
    borderRadius: 10,
    paddingLeft: 20,
    paddingRight: 20,
    // backgroundColor: "rgba(250, 250, 250, 1)",
    borderColor: "#BDBDBD",
    textAlign: "right",
  },
  addressDetailsInputs: {
    WebkitBoxOrient: "vertical",
    flexDirection: "column",

    WebkitBoxPack: "start",
    justifyContent: "flex-start",
    display: "flex",
    alignItems: "flex-end",
    WebkitBoxAlign: "end",
    borderWidth: 1,
    marginTop: 30,
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    paddingLeft: 20,
    paddingRight: 20,

    // backgroundColor: "rgba(250, 250, 250, 1)",
    borderColor: "#BDBDBD",
    flex: 90,
    height: "100%",
  },

  confirmButtonsContainer: {
    display: "flex",
    flexDirection: "row-reverse",
    bottom: 0,
    color: "white",
    height: 50,
    zIndex: 2,
    width: "100%",
    backgroundColor: "#7178fc",
    justifyContent: "center",
    alignItems: "center",
    WebkitBoxAlign: "center",
    position: "fixed",
  },

  confirmButton: {
    bottom: 0,
    color: "white",
    height: 50,
    zIndex: 2,
    display: "flex",
    border: "solid",
    borderColor: "white",
    borderWidth: 1,
    flex: 1,
    backgroundColor: "#7178fc",
    justifyContent: "center",
    alignItems: "center",
    WebkitBoxAlign: "center",
  },

  modalConfirmButton: {
    bottom: 0,
    color: "white",
    height: 50,
    zIndex: 2,
    display: "flex",
    width: "100%",
    backgroundColor: "#7178fc",
    justifyContent: "center",
    alignItems: "center",
    WebkitBoxAlign: "center",
    position: "sticky",
  },
  buttonText: {
    color: "white",
    fontSize: 16,
    textAlignVertical: "center",
    textAlign: "center",
    width: "100%",
  },
  addressDetailsView: {
    WebkitBoxOrient: "horizontal",
    flexDirection: "row",
    flex: 99,
    height: 50,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    WebkitBoxAlign: "center",
    border: "solid",
    borderWidth: 0.5,
    paddingLeft: 20,
    paddingRight: 20,
    backgroundColor: "rgba(250, 250, 250, 1)",
    borderColor: "#BDBDBD",
    marginLeft: 10,
  },
  addressDetailsEmptyText: {
    flex: 1,
    color: "black",
    textAlignVertical: "center",
    textAlign: "right",
    flexWrap: "wrap",
    fontSize: 12,
  },
  addressDetailsContainer: {
    WebkitBoxOrient: "horizontal",
    flexDirection: "row",
    display: "flex",
    height: 50,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    WebkitBoxAlign: "center",
  },
  addressDetailsContainerModal: {
    WebkitBoxOrient: "horizontal",
    flexDirection: "row",
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
    alignItems: "flex-start",
    WebkitBoxAlign: "start",
  },
  addressDetailsLeftBarModal: {
    height: "100%",
    backgroundColor: "#26D1B2",
    flex: 1,
    marginTop: 30,
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
  },
  addressDetailsLeftBar: {
    height: 50,
    backgroundColor: "#26D1B2",
    flex: 1,
    marginRight: 10,
  },
  searchResultText: {
    color: "gray",
    textAlignVertical: "center",
    textAlign: "right",
    flexWrap: "wrap",
    fontSize: 12,
    marginRight: 5,
  },
  searchResultRow: {
    WebkitBoxOrient: "horizontal",
    flexDirection: "row",

    WebkitBoxPack: "end",
    justifyContent: "flex-end",
    alignItems: "center",
    WebkitBoxAlign: "center",
    display: "flex",
    color: "gray",
    width: "95%",
    border: "solid",
    backgroundColor: "rgba(250, 250, 250, 1)",
    marginBottom: 5,
    borderWidth: 0.5,
    borderRadius: 10,
    paddingRight: 10,
    paddingLeft: 10,
    borderColor: "gray",
    height: 50,
  },
  firstTimeLoadingIndicator: {
    position: "absolute",
    alignItems: "center",
    WebkitBoxAlign: "center",
    display: "flex",
    WebkitBoxOrient: "vertical",
    flexDirection: "column",
    justifyContent: "center",
    WebkitBoxPack: "center",
    zIndex: 5,
    left: 0,
    right: 0,
    marginTop: 80,
  },
  anyRequestTextBoxContainer: {
    WebkitBoxOrient: "horizontal",
    flexDirection: "row",
    display: "flex",

    WebkitBoxPack: "end",
    justifyContent: "flex-end",
    alignItems: "center",
    WebkitBoxAlign: "center",
    backgroundColor: Colors.White,
    width: "90%",
    height: 100,
    shadowColor: Colors.BackgroundColor,
    shadowOpacity: 0.5,
    shadowRadius: 2,
    shadowOffset: {
      height: 1,
      width: 0,
    },
  },
  anyRequestTextBoxLeftt: {
    WebkitBoxOrient: "vertical",
    flexDirection: "column",
    display: "flex",

    WebkitBoxPack: "start",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    WebkitBoxAlign: "end",
    paddingRight: 5,
    height: 100,
    flex: 99,
  },
  anyRequestTextBoxRight: {
    height: 100,
    backgroundColor: "#26D1B2",
    flex: 1,
  },
  topic: {
    fontSize: 12,
    color: Colors.Gray,
    marginRight: 10,
    marginTop: 10,
    marginBottom: 5,
  },
  confirmButtonModalActive: {
    bottom: 0,
    height: 50,
    width: "100%",
    backgroundColor: Colors.ActiveButton,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    WebkitBoxAlign: "center",
    alignSelf: "flex-end",
  },
  confirmButtonModalInactive: {
    bottom: 0,
    height: 50,
    width: "100%",
    backgroundColor: Colors.InactiveButton,
    justifyContent: "center",
    alignItems: "center",
    WebkitBoxAlign: "center",
    alignSelf: "flex-end",
  },
  markerFixed: {
    display: "flex",
    position: "absolute",
    left: 0,
    right: 0,
    top: -70,
    bottom: 0,
    alignItems: "center",
    WebkitBoxAlign: "center",
    justifyContent: "center",
    WebkitBoxPack: "center",
  },
};
